import React, { useContext } from 'react'
import VersionCards from './VersionCards'

const Versions = (props) => {
    const { Context, versions } = props
    const { wrongWords2, wrongWords1, assessmentVersion1, assessmentVersion2, version1, version2, setVersion1, setVersion2 } = useContext(Context)

    return (
        <VersionCards
            assessmentVersion1={assessmentVersion1}
            assessmentVersion2={assessmentVersion2}
            version1={version1}
            version2={version2}
            setVersion1={setVersion1}
            setVersion2={setVersion2}
            versions={versions}
            wrongWords2={wrongWords2}
            wrongWords1={wrongWords1}
        />
    )
}

export default Versions